import { LIST_ITEMS_PER_PAGE_LIST } from '../../constants/constants';
import { TConfigSetupActions } from './config-setup.actions';
import { TConfigSetupActionType, TConfigSetupState } from './config-setup.models';

export const intialState: TConfigSetupState = {
  holidayListingInfo: null,
  holidayListingPagination: { pageNo: 1, pageSize: LIST_ITEMS_PER_PAGE_LIST[0] },
};

export function configSetupReducer(state = intialState, action: TConfigSetupActions): TConfigSetupState {
  switch (action.type) {
    case TConfigSetupActionType.SetHolidayListPagination:
      return {
        ...state,
        holidayListingPagination: action.pagination,
      };
    case TConfigSetupActionType.GetHolidayList:
      return {
        ...state,
        holidayListingInfo: null,
      };
    case TConfigSetupActionType.GetHolidayListSuccess:
      return {
        ...state,
        holidayListingInfo: {
          res: action.holidayListRes,
          fetchReason: action.fetchReason,
        },
      };
    default:
      return state;
  }
}
